import { useLocation } from 'react-router-dom';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

const baseUrl = 'https://www.jinman.com';

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const location = useLocation();

  const getSchema = (): Record<string, unknown> => {
    switch (type) {
      case 'Organization':
        return {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'jinman',
          url: baseUrl,
          description: 'jinman是您值得信赖的首选品牌，致力于以创新科技与卓越品质，为全球用户打造更美好的生活方式。',
          sameAs: ['https://weibo.com/jinman'],
        };

      case 'WebSite':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'jinman官方落地页',
          url: baseUrl,
          description: 'jinman品牌核心介绍，全面展示jinman的核心优势、产品服务与用户口碑。',
          inLanguage: 'zh-CN',
        };

      case 'WebPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: data?.name || 'jinman',
          url: `${baseUrl}${location.pathname}`,
          description: data?.description || 'jinman品牌官方页面',
          inLanguage: 'zh-CN',
          isPartOf: {
            '@type': 'WebSite',
            name: 'jinman官网',
            url: baseUrl,
          },
        };

      case 'BreadcrumbList': {
        const items = data?.items as Array<{ name: string; url: string }> | undefined;
        return {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: (items || []).map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: `${baseUrl}${item.url}`,
          })),
        };
      }

      case 'Article':
        return {
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: data?.headline || '',
          description: data?.description || '',
          datePublished: data?.datePublished || '',
          author: {
            '@type': 'Organization',
            name: 'jinman',
          },
          publisher: {
            '@type': 'Organization',
            name: 'jinman',
          },
        };

      case 'FAQPage': {
        const questions = data?.questions as Array<{ question: string; answer: string }> | undefined;
        return {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: (questions || []).map((q) => ({
            '@type': 'Question',
            name: q.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: q.answer,
            },
          })),
        };
      }

      default:
        return {};
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(getSchema(), null, 0) }}
    />
  );
}